import { Accordion, AccordionDetails, Box, Button, Container, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { AccountCircle, ArrowBackIos, CheckCircle, CloudDownload, CloudUpload, OfflinePin, PlayCircleFilledWhite, Save } from "@mui/icons-material";
import "moment/locale/tr";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import DocumentPopup from "../../components/Popup/DocumentPopup";
import RequestCard from "../../components/RequestCard/RequestCard";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";
import {
    autonomousDetailNull,
    getTaskDetailById,
    autonomousMaintenanceAssign,
    setAutonomousMaintenanceAssign,
    autonomousMaintenanceCloaseComplete,
    startAutonomousMaintenance,
    setStartAutonomousMaintenance,
    autonomousMaintenancePause,
    autonomousMaintenancePlayOrClose,
    setAutonomousMaintenancePlayOrClose,
    saveTask,
    setSaveTask,
    deleteAutonomousFiles,
    addAutonomousFiles,
    getAutonomousFiles,
} from "../../store/actions/AutonomousMaintenanceDetailActions";
import { getFormDataFromFiles, getSelectedFileNames } from "../../common";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";

const useStyles = makeStyles((theme) => ({
    colorized: {
        width: 20,
        height: 20,
    },
    speedDial: {
        position: "absolute",
        bottom: theme.spacing(4),
        right: theme.spacing(2),
    },
    backdrop: {
        zIndex: 1,
        color: "#fff",
    },
    iconButtonLabel: {
        display: "flex",
        flexDirection: "column",
    },
    popupElement: {
        width: "100%",
        marginTop: 10,
    },
}));

const iconButtonStyle = {
    width: 60,
    height: 60,
    padding: 0,
};

export default function AutonomousMaintenanceDetail(props) {
    const dispatch = useDispatch();
    const AutonomousMaintenanceDetail = useSelector((state) => state.AutonomousMaintenanceDetail);
    const classes = useStyles();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [userID, setUserID] = useState();
    const { t } = useTranslation("translation");
    const [rows, setRows] = useState([]);
    //load detail data for popup
    const [sparePart, setSparePart] = useState("");
    const [disableNote, setDisableNote] = useState(false);
    const [disableDocumentButton, setDisableDocumentButton] = useState(false);
    const [disableAssignButton, setDisableAssignButton] = useState(false);
    const [disableStartButton, setDisableStartButton] = useState(false);
    const [disableFinishButton, setDisableFinishButton] = useState(false);
    const [disablePauseButton, setDisablePauseButton] = useState(false);
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    const [disableTaskCheckItemsButton, setDisableTaskCheckItemsButton] = useState(false);
    //document popup
    const [documentPopup, setDocumentPopup] = useState(false);
    let [documentList, setDocumentList] = useState([]);

    //notes
    const [notes, setNotes] = useState("");

    const history = useHistory();

    useEffect(() => {
        //component didmount for getting info
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserID(oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", ""));
        loadHandler();

        return () => {
            dispatch(autonomousDetailNull());
        };
    }, []);

    useEffect(() => {
        // getting data from taskdetailbyid
        if (AutonomousMaintenanceDetail?.taskDetailById) {
            genericLoadRows(AutonomousMaintenanceDetail.taskDetailById);
            setPageLoaded(true);
        }
    }, [AutonomousMaintenanceDetail?.taskDetailById]);

    useEffect(() => {
        // getting data from starting task
        if (AutonomousMaintenanceDetail?.autonomousMaintenance) {
            genericLoadRows(AutonomousMaintenanceDetail.autonomousMaintenance.resultObject);
            setPageLoaded(true);
            dispatch(setStartAutonomousMaintenance(undefined));
        }
    }, [AutonomousMaintenanceDetail?.autonomousMaintenance]);

    useEffect(() => {
        // task asignee payload
        if (AutonomousMaintenanceDetail?.autonomousMaintenanceAssign) {
            genericLoadRows(AutonomousMaintenanceDetail.autonomousMaintenanceAssign.resultObject);
            setPageLoaded(true);
            dispatch(setAutonomousMaintenanceAssign(undefined));
        }
    }, [AutonomousMaintenanceDetail?.autonomousMaintenanceAssign]);

    useEffect(() => {
        // task completion res
        if (AutonomousMaintenanceDetail?.setAutonomousMaintenanceCloaseComplete) {
            genericLoadRows(AutonomousMaintenanceDetail.setAutonomousMaintenanceCloaseComplete.resultObject);
            setPageLoaded(true);
            dispatch(setAutonomousMaintenancePlayOrClose(undefined));
        }
    }, [AutonomousMaintenanceDetail?.setAutonomousMaintenanceCloaseComplete]);

    useEffect(() => {
        //task saving res
        if (AutonomousMaintenanceDetail?.autonomousMaintenanceSave) {
            genericLoadRows(AutonomousMaintenanceDetail.autonomousMaintenanceSave.resultObject);
            setPageLoaded(true);
            dispatch(setSaveTask(undefined));
        }
    }, [AutonomousMaintenanceDetail?.autonomousMaintenanceSave]);

    useEffect(() => {
        // task closure res
        if (AutonomousMaintenanceDetail?.autonomousMaintenanceClose) {
            genericLoadRows(AutonomousMaintenanceDetail.autonomousMaintenanceClose.resultObject);
            setPageLoaded(true);
            dispatch(setAutonomousMaintenancePlayOrClose(undefined));
        }
    }, [AutonomousMaintenanceDetail?.autonomousMaintenanceClose]);

    useEffect(() => {
        if (AutonomousMaintenanceDetail?.autonomousFiles) {
            setDocumentList(AutonomousMaintenanceDetail.autonomousFiles);
            setDocumentPopup(true);
            AutonomousMaintenanceDetail.autonomousFiles = null;
        }
    }, [AutonomousMaintenanceDetail?.autonomousFiles]);

    const loadHandler = () => {
        dispatch(getTaskDetailById(queryString.parse(window.location.search).id));
    };
    //generic function to load row data
    const genericLoadRows = (result) => {
        setRows(result);
        handleDisableParts(result.taskStatus);
    };

    //go breakdown detail page
    const backToBreakdownListPage = () => {
        props.history.goBack();
    };

    //assign to me
    const assignToMe = (rowData) => {
        let payload = {
            id: rowData.id,
            asigneeCode: userID,
        };
        dispatch(autonomousMaintenanceAssign(payload));
    };

    //start task
    const startTask = (rowData) => {
        //continue task
        if (rowData.taskStatus == 4) {
            let payload = {
                id: rowData.id,
                // task: "Play"
            };
            dispatch(autonomousMaintenancePause(payload));
        }
        //start task
        else {
            let payload = {
                id: rowData.id,
                // task: "Start"
            };
            dispatch(startAutonomousMaintenance(payload));
        }
    };

    //complete task
    const completeTask = (rowData) => {
        const data = {
            id: rowData.id,
            maintenanceOrderId: rowData.maintenanceOrderId,
            plantId: 1,
            notes: notes,
            freeTxt1: sparePart,
            plannedDate: new Date(),
        };
        let payload = {
            data,
            id: rowData.id,
        };

        dispatch(autonomousMaintenanceCloaseComplete(payload));
    };

    const closeTask = (rowData) => {
        const data = {
            id: rowData.id,
            maintenanceOrderId: rowData.maintenanceOrderId,
            plantId: 1,
            notes: notes,
            freeTxt1: sparePart,
            plannedDate: new Date(),
        };

        let payload = {
            data,
            id: rowData.id,
        };
        dispatch(autonomousMaintenancePlayOrClose(payload));
    };

    //update task
    const updateTask = (rowData) => {
        const data = {
            id: rowData.id,
            maintenanceOrderId: rowData.maintenanceOrderId,
            plantId: 1,
            notes: notes,
            freeTxt1: sparePart,
            plannedDate: new Date(),
        };

        dispatch(saveTask(data));
    };

    const handleNotes = (event) => {
        setNotes(event.target.value);
    };

    const disable = (list) => {
        setDisableNote(list[0]);
        setDisableDocumentButton(list[2]);
        setDisableAssignButton(list[3]);
        setDisableStartButton(list[4]);
        setDisableFinishButton(list[5]);
        setDisableSaveButton(list[6]);
        setDisablePauseButton(list[7]);
        setDisableTaskCheckItemsButton(list[8]);
    };

    //enable disable for status
    const handleDisableParts = (status) => {
        //Atama Bekliyor
        if (status === 1) {
            disable([true, true, true, false, true, true, true, true, false]);
        }

        //Atandı
        else if (status === 2) {
            disable([true, true, true, true, false, true, true, true, false]);
        }

        //Başlandı
        else if (status === 3) {
            disable([false, false, false, true, true, true, true, false, false]);
        }

        //Durduruldu
        else if (status === 4) {
            disable([true, true, true, true, true, true, true, true, false]);
        }

        //Tamamlandı
        else if (status === 5) {
            disable([false, false, false, true, true, false, false, true, false]);
        }

        //Kapandı
        else if (status === 6) {
            disable([true, true, true, true, true, true, true, true, true]);
        }
    };

    // File Management
    const handleDocumentOpen = () => {
        dispatch(getAutonomousFiles(rows.maintenanceOrderId));
    };

    const closeDocumentPopup = () => {
        setDocumentPopup(false);
    };

    const DeleteFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            autonomousId: rows.maintenanceOrderId,
            fileNames: selectedFileNames,
        };
        dispatch(deleteAutonomousFiles(payload));
        setDocumentPopup(false);
    };

    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const UploadFiles = (files) => {
        const formData = getFormDataFromFiles(files);
        const payload = {
            autonomousId: rows.maintenanceOrderId,
            data: formData,
        };
        dispatch(addAutonomousFiles(payload));
        setIsFileUploaderPopupOpen(false);
    };

    return (
        <div>
            {pageLoaded === true ? (
                <Container id="amd_Container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
                    <Grid id="amd_Grid" container alignItems="center">
                        <Grid id="amd_Grid_1" item xs={1}>
                            <IconButton id="amd_IconButton" onClick={backToBreakdownListPage} size="large">
                                <ArrowBackIos id="amd_ArrowBackIos" fontSize="inherit" align="end" />
                            </IconButton>
                        </Grid>
                        <Grid id="amd_Grid_2" item xs={11}>
                            <Typography id="amd_Typography" variant="h6" gutterBottom style={{ fontSize: 15 }}>
                                {rows.equipmentDetailedCode}
                            </Typography>
                        </Grid>
                    </Grid>

                    <RequestCard id="amd_RequestCard" rows={[rows]} detail={true} page="autonomousmaintenance" taskName="Task" callName="Plan" isAutonomousMaintenance={true} />

                    <Box id="amd_Box" pt={1} pb={1} style={{ marginTop: 10 }} border={1} borderRadius="10px">
                        <Grid id="amd_Grid_3" container>
                            <Grid id="amd_Grid_4" item xs={12}>
                                <TextField
                                    id="amd_TexField"
                                    style={{ width: "90%", marginTop: 15 }}
                                    label={t("Note")}
                                    multiline
                                    variant="outlined"
                                    defaultValue={rows.notes}
                                    onChange={handleNotes}
                                    disabled={disableNote}
                                />
                            </Grid>
                            <Grid id="amd_Grid_5" item xs={12} align="center">
                                <Accordion id="amd_Accordion" style={{ width: "90%", marginTop: 15 }}>
                                    <AccordionDetails id="amd_AccordionDetails">
                                        <Grid container id="amd_Container_1">
                                            <Grid id="amd_Grid_6" item xs={12}>
                                                <Button
                                                    id="amd_Button"
                                                    disabled={disableTaskCheckItemsButton}
                                                    style={{ width: "80%", marginTop: 15, marginBottom: 10 }}
                                                    onClick={() => history.push("/autonomous-task-check-list?id=" + rows.id, { isTaskStarted: disableAssignButton && disableStartButton })}
                                                    variant="contained"
                                                    color="secondary"
                                                    startIcon={<PlaylistAddCheckRoundedIcon />}
                                                >
                                                    {t("CheckItems")}
                                                </Button>
                                            </Grid>
                                            <Grid id="amd_Grid_8" item xs={6}>
                                                <Tooltip id="amd_Tooltip" title={t("ShowFiles")}>
                                                    <IconButton id="amd_IconButton_2" onClick={handleDocumentOpen} size="large">
                                                        <CloudDownload id="amd_CloudDownLoad" sx={iconButtonStyle} style={{ fill: "#757575" }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                            <Grid id="amd_Grid_9" item xs={6}>
                                                <Tooltip id="amd_Tooltip_1" title={t("UploadFile")}>
                                                    <IconButton id="amd_IconButton_3" component="label" disabled={disableDocumentButton} onClick={() => setIsFileUploaderPopupOpen(true)} size="large">
                                                        <CloudUpload id="amd_CreateNewFolder" sx={iconButtonStyle} style={{ fill: "#757575" }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box id="amd_Box" display="flex" alignItems="center" justifyContent="center" style={{ align: "center" }}>
                        <Grid id="amd_Grid_10" container alignItems="center" justifyContent="center" wrap="nowrap">
                            <Grid id="amd_Grid_11" item xs={3}>
                                <IconButton id="amd_IconButton_4" onClick={() => assignToMe(rows)} disabled={disableAssignButton} className={classes.iconButtonLabel} size="large">
                                    <AccountCircle id="amd_AccountCircle" sx={iconButtonStyle} style={{ fill: "#536dfe" }} />
                                    <Typography id="amd_Typography_1" variant="subtitle2">
                                        {t("AssignToMe")}
                                    </Typography>
                                </IconButton>
                            </Grid>
                            {rows.taskStatus == 2 ? (
                                <Grid id="amd_Grid_12" item xs={3}>
                                    <IconButton id="amd_IconButton_5" onClick={() => startTask(rows)} disabled={disableStartButton} className={classes.iconButtonLabel} size="large">
                                        <PlayCircleFilledWhite id="amd_PlayCircleFilledWhite" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                                        <Typography id="amd_Typography_2" variant="subtitle2">
                                            {t("Start")}
                                        </Typography>
                                    </IconButton>
                                </Grid>
                            ) : rows.taskStatus == 3 ? (
                                <Grid id="amd_Grid_13" item xs={3}>
                                    <IconButton id="amd_IconButton_6" onClick={() => completeTask(rows)} disabled={disablePauseButton} className={classes.iconButtonLabel} size="large">
                                        <CheckCircle id="amd_CheckCircle" sx={iconButtonStyle} style={{ fill: "#4caf50" }} />
                                        <Typography id="amd_Typography_3" variant="subtitle2">
                                            {t("Complete")}
                                        </Typography>
                                    </IconButton>
                                </Grid>
                            ) : null}
                            <Grid id="amd_Grid_14" item xs={3}>
                                <IconButton id="amd_IconButton_7" onClick={() => updateTask(rows)} disabled={disableSaveButton} className={classes.iconButtonLabel} size="large">
                                    <Save id="amd_save" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                                    <Typography id="amd_Typography_4" variant="subtitle2">
                                        {t("Save")}
                                    </Typography>
                                </IconButton>
                            </Grid>
                            <Grid id="amd_Grid_15" item xs={3}>
                                <IconButton id="amd_IconButton_8" onClick={() => closeTask(rows)} disabled={disableFinishButton} className={classes.iconButtonLabel} size="large">
                                    <OfflinePin id="amd_OfflinePin" sx={iconButtonStyle} style={{ fill: "#4caf50" }} />
                                    <Typography id="amd_Typography_5" variant="subtitle2">
                                        {t("Close")}
                                    </Typography>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Box>

                    {documentPopup === true ? (
                        <DocumentPopup
                            id="amd_DocumentPopup"
                            isMaintenanceDocuments={true}
                            isEquipmentDocuments={false}
                            list={documentList}
                            open={documentPopup}
                            deleteFile={DeleteFile}
                            close={() => closeDocumentPopup()}
                        />
                    ) : null}

                    {isFileUploaderPopupOpen ? <FileUploaderPopup isOpen={isFileUploaderPopupOpen} onCancel={() => setIsFileUploaderPopupOpen(false)} onConfirm={UploadFiles} /> : null}
                </Container>
            ) : null}
            <LoadingBackdrop id="amd_lbd" />
        </div>
    );
}
